export const routes = {
  DASHBOARD: '/',
  WIDGET_DETAILS: '/widget/:type',
  WIDGET_DIALOG: '/widget/:type/dialog',
  UPGRADE_MODAL: '/widget/:type/upgrade',
  ERROR_MODAL: '/widget/:type/error',
  ANY: '*',
};
